module.exports = __webpack_public_path__ + "static/media/familysearch-tree.8af1dd05.svg";